import { render, staticRenderFns } from "./MateriList.vue?vue&type=template&id=4f18ff40&scoped=true"
import script from "./MateriList.vue?vue&type=script&lang=js"
export * from "./MateriList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18ff40",
  null
  
)

export default component.exports